
export const translateResourceString = function (itemKey, ...formatChars) {
    if (window.clientTranslationStrings) {
        var translation = window.clientTranslationStrings[itemKey];
        if (translation !== null && translation !== undefined) {
            return window.clientTranslationStrings[itemKey].formatUnicorn(...formatChars);
        }
    }
    return itemKey;
}

export const addResourceStrings = function (resourceStrings) {
    if (!window.clientTranslationStrings) {
        window.clientTranslationStrings = resourceStrings
    } else {
        window.clientTranslationStrings = { ...window.clientTranslationStrings, ...resourceStrings };
    }
}

String.prototype.formatUnicorn = String.prototype.formatUnicorn ||
    function () {
        "use strict";
        if (this === undefined) return '';
        var str = this.toString();
        if (arguments.length) {
            var t = typeof arguments[0];
            var key;
            var args = ("string" === t || "number" === t) ?
                Array.prototype.slice.call(arguments)
                : arguments[0];

            for (key in args) {
                str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
            }
        }

        return str;
    };